<template>
  <div v-loading="loading" class="ec-web031 container w-full mx-auto px-4">
    <el-breadcrumb separator="/" class="px-0">
      <el-breadcrumb-item>
        <a :href="baseUrl">{{ this.shopName }}</a></el-breadcrumb-item
      >
      <el-breadcrumb-item>{{ $t('ec-line031.title') }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="flex flex-row w-full justify-center">
      <h1 class="text-primary text-xl">{{ title }}</h1>
    </div>
    <div v-if="liffIdExists">
      <div class="flex flex-row w-full mt-6 justify-center">
        <div class="flex justify-center">
          <line-button class="el-button rounded-full font-black w-60" @click="onLoginByLine">{{
            $t('ec-line031.content.form.lineLogin')
          }}</line-button>
        </div>
      </div>
      <div class="flex flex-row w-full mt-6">
        <div class="leading-none relative w-full h-8 text-center">
          <span class="w-0 h-8 inline-block align-middle">
            <div class="absolute top-0 left-0 border-b border-gray-150 border-solid w-full h-4"></div>
          </span>
          <span class="relative z-10 bg-gray text-gray-150 px-4">{{ $t('ec-line031.content.form.or') }}</span>
        </div>
      </div>
    </div>

    <el-form ref="form" :model="form" :rules="rules" label-position="top" class="t-form no-required">
      <el-form-item :label="$t('common.memberInformation.email')" prop="email">
        <el-input v-model="form.email" :placeholder="$t('common.informationPlaceholder.emailPlaceholder')" />
      </el-form-item>
      <el-form-item :label="$t('common.memberInformation.password')" prop="password">
        <el-input v-model="form.password" type="password" :placeholder="$t('common.informationPlaceholder.password')" show-password />
        <div v-if="isAccountLocked" class="text-lg text-red mt-2" style="white-space: pre-line;">
          <span>{{ $t('ec-line031.content.form.accountLockedMessage1') }}</span>
          <span class="text-blue-650 underline cursor-pointer" @click="onForgotPassword">{{ $t('ec-line031.content.form.accountLockedMessage2') }}</span>
          <span style="white-space: pre-line;">{{ $t('ec-line031.content.form.accountLockedMessage3') }}</span>
        </div>
      </el-form-item>

      <div v-show="commonMessage" class="w-fulll text-left text-red text-xs">{{ commonMessage }}</div>
      <div class="w-full mx-auto text-center">
        <el-button class="submit-btn" @click="onSubmit">
          {{ $t('ec-line031.content.form.loginWithEmail') }}
        </el-button>
      </div>
      <div class="w-full mx-auto text-center">
        <el-button type="text" class="underline text-primary-50 text-xs" @click="onForgotPassword">{{
          $t('ec-line031.content.form.forgotPassword')
        }}</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import liff from '@line/liff'
import LineButton from '@/components/LineButton.vue'
import { AuthService } from '@/services'
import { APP_STATUS, COOKIE_ACCESS_TOKEN, LINE_LOGIN_FROM_LOGIN_PAGE, PROVIDER } from '@/constants'
import { ENV_KEY } from '@/constants/env'
import BreadcrumbMixin from '@/mixins/breadcrumb'
import store from '@/store'
import * as RouterPage from '@/constants/route-page'

export default {
  components: { LineButton },
  mixins: [BreadcrumbMixin],
  data() {
    return {
      title: this.$t('ec-line031.title'),
      form: {
        email: '',
        password: '',
      },
      commonMessage: '',
      rules: {
        email: [
          this.Utils.validate.required(this.$t('common.validate.field.email')),
          this.Utils.validate.emailFormat(this.$t('common.validate.field.email')),
        ],
        password: [
          this.Utils.validate.required(this.$t('common.validate.field.password')),
          this.Utils.validate.password(this.$t('common.validate.field.password')),
        ],
      },
      loading: false,
      isAccountLocked: false,
    }
  },
  beforeRouteEnter(_to, _from, next) {
    if (store.state.auth.user) {
      next(RouterPage.EC_LINE009)
    }
    next()
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return

        this.loading = true
        this.isAccountLocked = false

        AuthService.loginCustomer({
          login_id: this.form.email,
          password: this.form.password,
          client_id: this.$store.getters['env/GET_KEY'](ENV_KEY.CLIENT_ID),
          shop_id: this.$store.getters['env/GET_KEY'](ENV_KEY.SHOP_ID),
        })
          .then(({ data }) => {
            Cookies.set(COOKIE_ACCESS_TOKEN, data.access)
          })
          .then(() => this.$store.dispatch('auth/getAuth', { provider: PROVIDER.CUSTOMER }))
          .then(() => this.$router.push(this.$routePage.EC_LINE009))
          .catch((err) => {
            if (err.response.data.meta.app_status_code === APP_STATUS.ERROR_USER_ACCOUNT_LOCKED) {
              this.isAccountLocked = true
            } else {
              this.handleError(err)
            }
          })
          .finally(() => (this.loading = false))
      })
    },

    onLoginByLine() {
      const url = new URL(
        `${this.$store.getters['env/GET_KEY'](ENV_KEY.BASE_URL)}${process.env.VUE_APP_PREFIX}${
          this.$routePage.EC_LINE009
        }`
      )
      url.searchParams.append(LINE_LOGIN_FROM_LOGIN_PAGE, true)

      if (this.liffIdExists) {
        liff.login({
          redirectUri: url.toString(),
        })
      }
    },

    onForgotPassword() {
      this.$router.push(this.$routePage.EC_LINE032)
    },
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.$t('ec-line031.description', { shop_name: this.shopName }),
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: this.$t('ec-line031.keyword', { shop_name: this.shopName }),
        },
      ],
    }
  },
}
</script>
